import React, { FC } from 'react';
import ItineraryProvider from 'clientState/providers/ItinerarySelectionProvider/ItineraryProvider';
import ThreeColumnsItinerary from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItinerary';
import { ThreeColumnsItineraryType } from '@components/Results/Components/ThreeColumnsItinerary/types';
import ItineraryUnavailableOverlay from '@components/Results/Components/ThreeColumnsItinerary/ItineraryUnavailableOverlay/ItineraryUnavailableOverlay';

export type AlternativeItineraryCardProps = {
  itinerary: ThreeColumnsItineraryType;
  isClickable?: boolean;
  hasAlternativeItineraryDecorator?: boolean;
  isAlternativeItinerary?: boolean;
  isSelectedItinerary?: boolean;
  isAlternativeTopSection?: boolean;
  isBrokenFlow?: boolean;
  nonIssuable?: boolean;
  isUnavailable?: boolean;
  isAlternativeItineraryOnModal?: boolean;
  onSelectAlternativeItinerary?: () => void;
  onSelectOriginalItinerary?: () => void;
  overrideAction?: boolean;
  trackingHandler: (
    event: string,
    clickedElement: string,
    closingMethod?: string
  ) => void;
};

const AlternativeItineraryDoubleCardLayerCard: FC<
  AlternativeItineraryCardProps
> = ({
  itinerary,
  isClickable = true,
  hasAlternativeItineraryDecorator = false,
  isAlternativeItinerary = false,
  isSelectedItinerary = false,
  isAlternativeTopSection = false,
  isBrokenFlow,
  nonIssuable,
  isUnavailable = false,
  isAlternativeItineraryOnModal = false,
  onSelectAlternativeItinerary,
  overrideAction,
  trackingHandler,
  onSelectOriginalItinerary,
}) => {
  return (
    <ItineraryProvider itinerary={itinerary}>
      <ItineraryUnavailableOverlay
        withOverlay={isUnavailable}
        isBrokenFlow={isBrokenFlow}
      >
        <ThreeColumnsItinerary
          itinerary={itinerary}
          position={0}
          hasRetailingTechniques={false}
          isAlternativeItinerary={isAlternativeItinerary}
          isSelectedItinerary={isSelectedItinerary}
          isClickable={isClickable}
          nonIssuable={nonIssuable}
          hasAlternativeItineraryDecorator={hasAlternativeItineraryDecorator}
          isAlternativeTopSection={isAlternativeTopSection}
          isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
          onSelectAlternativeItinerary={onSelectAlternativeItinerary}
          overrideAction={overrideAction}
          trackingHandler={trackingHandler}
          onSelectOriginalItinerary={onSelectOriginalItinerary}
        />
      </ItineraryUnavailableOverlay>
    </ItineraryProvider>
  );
};

export default AlternativeItineraryDoubleCardLayerCard;
